import React from 'react'
import useTrans from '../../../hooks/useTrans'
import FormField from '../../atoms/FormField/FormField'
import FormInput from '../../atoms/FormInput/FormInput'
import { useFormik } from 'formik'
import * as yup from 'yup'
import NewModal from '../../molecules/NewModal/NewModal'
import { Button } from '../../atoms'

const NomeLavorazioneModal = ({ open, setOpen, nomeLavorazione, setNomeLavorazione, onSubmit }) => {
  const t = useTrans()

  const validationSchema = yup.object({
    nomeLavorazione: yup
      .string()
      .matches(/^[^0-9]*$/, 'Solo lettere')
      .min(3, t('Minimo 3 caratteri'))
      .max(14, t('Massimo 14 caratteri')),
  })

  const formik = useFormik({
    initialValues: {
      nomeLavorazione: nomeLavorazione || '',
    },
    validationSchema,
    onSubmit: (values) => {
      onSubmit(values.nomeLavorazione)
    }
  })

  const onClose = () => {
    setOpen(false)
    formik.resetForm()
  }

  return (
    <NewModal
      visible={open}
      onClose={onClose}
      title={t("Inserisci nome lavorazione")}
      actions={[
        <Button
          label={t('Annulla')}
          variant="secondary"
          size="medium"
          onClick={onClose}
        />,
        <Button
          label={t('Conferma nome')}
          variant="primary"
          size="medium"
          type="submit"
          disabled={!formik.isValid || formik.isSubmitting}
          onClick={() => formik.handleSubmit()}
        />,
      ]}
    >
      <div className="nome-lavorazione-modal">
        <div>
          <p className="configurazione-prodotto__description configurazione-prodotto__description__lavorazione">
            {t(
              'Inserisci il nome lavorazione, se non specificato, verrà creato un identificativo automatico'
            )}
          </p>
          <FormField
            id={`nome_lavorazione`}
            status={
              formik.touched.nomeLavorazione && formik.errors.nomeLavorazione ? 'error' : undefined
            }
            errorMessage={formik.errors.nomeLavorazione ? formik.errors.nomeLavorazione : undefined}
            // infoMessage={nomeLavorazioneAssegnato}
          >
            <FormInput
              name="nomeLavorazione"
              value={formik.values.nomeLavorazione}
              placeholder={t("Nome lavorazione (opzionale)")}
              type="text"
              onChange={(e) => {
                formik.handleChange(e)
              }}
              onBlur={formik.handleBlur}
            />
          </FormField>
        </div>
      </div>
    </NewModal>
  )
}

export default NomeLavorazioneModal
